import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { campaignsRoutes } from './campaigns-routes';

export const CampaignsRouter: FC = () => {
    return (
        <Routes>
            {campaignsRoutes.map((route) =>
                route.index ? (
                    <Route key="index" index element={route.element} />
                ) : (
                    <Route key={route.path} path={route.path} element={route.element} />
                )
            )}
        </Routes>
    );
};
